export default __webpack_public_path__ + "static/media/603.be1f54da.gif";